<template>
  <div class="a-part-of">
    <div class="a-part-of__container">
      <div class="a-part-of__image">
        <!-- image thumbnail or image unavailable -->
        <ImageResponsiveWithErrorWrapper
          :id="imgUuid"
          size="post_small_variable_height"
          :alt="imageAlt"
          :is-text-item="isTextItem"
        />
      </div>
      <div class="a-part-of__description">
        <!-- image caption -->
        <div ref="heading" class="a-part-of__description-heading">
          {{ partOfHeading }}
        </div>
        <GuiLink
          v-if="heading"
          :to="to"
          class="a-part-of__heading"
          data-testid="imageCaption"
        >
          <span>{{ heading }}</span>
        </GuiLink>
        <p v-if="subheading" class="a-part-of__subheading">
          {{ subheading }}
        </p>
        <SearchCartouches
          v-if="is_deaccessioned"
          :item="item"
          :heading-level="2"
          :show-parent-tree="false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  GuiLink,
  useLocalization,
  ImageResponsiveWithErrorWrapper
} from "@thegetty-private/getty-ui";
import SearchCartouches from "@/components/atoms/searchCartouches/index.vue";

export default {
  name: "PartOf",
  components: {
    GuiLink,
    ImageResponsiveWithErrorWrapper,
    SearchCartouches
  },

  props: {
    /**
     * The primary text displayed below the image thumbnail
     */
    heading: {
      type: String,
      default: undefined
    },
    /**
     * The alt text for the image thumbnail
     */
    imageAlt: {
      type: String,
      default: undefined
    },
    /**
     * The uuid of the iiif image
     */
    imageUuid: {
      type: String,
      default: undefined
    },
    /**
     * The secondary text displayed below the image thumbnail, under heading
     */
    subheading: {
      type: String,
      default: undefined
    },
    /**
     * Boolean indicating whether or not the item contains text exclusively
     */
    isTextItem: {
      type: Boolean,
      default: false
    },
    /**
     * The router-link "to" property
     */
    to: {
      type: Object,
      default: undefined
    },
    /**
     * Whether the item is deaccessioned
     */
    // eslint-disable-next-line vue/prop-name-casing
    is_deaccessioned: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      imgUuid: this.imageUuid,
      // Assign props to item to pass in to SearchCartouche
      item: this.$props
    };
  },
  computed: {
    /**
     * The translated Part of heading
     *
     * @returns {string}
     */
    partOfHeading() {
      return this.translatePart("object_page.part_of");
    }
  },
  watch: {
    imageUuid() {
      this.imgUuid = this.imageUuid;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
